import React from 'react';
import MapSlider from './component';

export default React.memo(MapSlider);
